export const formatMMSS = (seconds?: number): string => {
  if (seconds == null || Number.isNaN(seconds)) return "00:00";
  const s = Math.max(0, Math.floor(seconds));
  const mins = Math.floor(s / 60);
  const secs = s % 60;
  return `${mins}:${secs.toString().padStart(2, "0")}`;
};
